export class 検索条件型 {
  商品区分: string | null;
  使用区分: string | null;
  並び順区分: string;

  検索文字列: string | null;
  商品名選択: 選択区分型;
  商品名カナ選択: 選択区分型;
  規格容量選択: 選択区分型;
  メーカー名選択: 選択区分型;
  メーカー名カナ選択: 選択区分型;

  検索コード: string | null;
  商品コード選択: 選択区分型;
  JANコード選択: 選択区分型;
  包装GTINコード選択: 選択区分型;
  販売GTINコード選択: 選択区分型;

  constructor(商品区分: string | null,
              使用区分: string | null,
              並び順区分: string,
              検索文字列: string | null,
              商品名選択: 選択区分型,
              商品名カナ選択: 選択区分型,
              規格容量選択: 選択区分型,
              メーカー名選択: 選択区分型,
              メーカー名カナ選択: 選択区分型,
              検索コード: string | null,
              商品コード選択: 選択区分型,
              JANコード選択: 選択区分型,
              包装GTINコード選択: 選択区分型,
              販売GTINコード選択: 選択区分型) {
    this.商品区分 = 商品区分;
    this.使用区分 = 使用区分;
    this.並び順区分 = 並び順区分;
    this.検索文字列 = 検索文字列;
    this.商品名選択 = 商品名選択;
    this.商品名カナ選択 = 商品名カナ選択;
    this.規格容量選択 = 規格容量選択;
    this.メーカー名選択 = メーカー名選択;
    this.メーカー名カナ選択 = メーカー名カナ選択;
    this.検索コード = 検索コード;
    this.商品コード選択 = 商品コード選択;
    this.JANコード選択 = JANコード選択;
    this.包装GTINコード選択 = 包装GTINコード選択;
    this.販売GTINコード選択 = 販売GTINコード選択;
  }
}

export function 検索条件初期値() {
  return new 検索条件型(null, null, '商品名カナ', '', 選択区分型.選択, 選択区分型.選択,
                      選択区分型.選択, 選択区分型.選択, 選択区分型.選択, null,
                      選択区分型.選択, 選択区分型.選択, 選択区分型.選択, 選択区分型.選択);
}

export enum 選択区分型 {
  選択 = '選択',
  非選択 = '非選択',
}
